module.exports = __webpack_public_path__ + "static/media/product15.a12e2519.jpg";